import React, { useState } from 'react';
import {
    UncontrolledPopover,
    UncontrolledCollapse,
    PopoverHeader,
    PopoverBody,
    Button
} from 'reactstrap';
import { useHistory } from "react-router";

//Context
import { useAuth } from '../../../context/auth';
const getManuais = (caminhoVirtual) => [
    {
        title: "RCC- Manual Cadastro Transportador",
        link: caminhoVirtual + "RCCManualCadastroTransportador.pdf"
    },
    {
        title: "RCC - Manual Cadastro Gerador",
        link: caminhoVirtual + "RCCManualCadastroGerador.pdf"
    },
    {
        title: "RCC - Manual Cadastro Destino Final",
        link: caminhoVirtual + "RCCManualCadastroDestinoFinal.pdf"
    },
    {
        title: "RSS - ManualCadastro Gerador",
        link: caminhoVirtual + "RSSManualCadastroGerador.pdf"
    },
    {
        title: "RGG - Manual Cadastro Transportador",
        link: caminhoVirtual + "RGGManualCadastroTransportador.pdf"
    },
    {
        title: "RGG - Manual Cadastro Grande Gerador",
        link: caminhoVirtual + "RGGManualCadastroGrandeGerador.pdf"
    },
    {
        title: "RGG - Manual Cadastro Destino Final",
        link: caminhoVirtual + "RGGManualCadastroDestinoFinal.pdf"
    },
    {
        title: "Manual Taxa Fislurb",
        link: caminhoVirtual + "ManualTaxaFislurb.pdf"
    },
];
function Popover({ id = "UncontrolledPopover" }) {
    const { setupSistema } = useAuth();
    const history = useHistory();
    
    const [mensagens, setMensagens] = useState([
        {
            title: "Manuais",
            collapse: false
        },
        {
            title: "O que é o Controle de Transporte de Resíduos (CTR)?",
            texto: () => (
                <div className='mt-2'>
                    <p> O Controle de Transporte de Resíduos (CTR) é o documento numerado que fornece informações sobre a geração, o transporte e o destinação final dos resíduos dos estabelecimentos grandes gerador à SP REGULA
                        A implementação do Controle de Transporte de Resíduos (CTR-E RGG) se deu por meio da resolução no 130/AMLURB/2019, visando preservar as regras que regem o segmento, sem alteração na legislação atual, criando mecanismos de controle e monitoramento.</p>

                    <p> O Controle de Transporte de Resíduos (CTR-E) é uma ferramenta de fiscalização e rastreabilidade criado para cadastrar todos os entes privados (geradores, transportadores, cooperativas e destinos finais),
                        que fazem parte dos sistemas de limpeza urbana e que geram mais de 200L/ díade resíduos. A tecnologia permite que a Prefeitura Municipal de São Paulo,
                        por meio da SP REGULA, saiba como o resíduo é coletado, transportado e por fim, destinado. Com isto, espera se melhorias na zeladoria urbana, na saúde pública,
                        além de economia de recursos públicos.</p>

                    <p> De acordo com a Legislação Vigente todos os estabelecimentos privados que geram mais de 200 litros / dia de resíduos devem realizar seu cadastro perante à SP REGULA,
                        a partir de autodeclaração, sendo os mesmos sujeitos às sanções e responsabilidades, de acordo com o ART. 299 do Código Penal.</p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Quem deve se cadastrar?",
            texto: () => (
                <div className='mt-2'>
                    <p> Todos os estabelecimentos considerados pela LEI como grande geradores, ou seja, geram mais de 200 litros / dia de resíduos devem realizar seu cadastro perante à SP REGULA,</p>

                    <p> No caso dos transportadores, é obrigatório que os mesmos tenham SEDE ou FILIAL aberta no município de São Paulo bem como o Ato de registro de funcionamento emitido pela Subprefeitura local e demais documentos exigidos no momento do cadastro sendo essa uma condição indispensável para poder prestar os serviços na capital.</p>

                    <p>   A coleta domiciliar do Município é realizada pelas Concessionarias LOGA e ECOURBIS e é destinada exclusivamente para as residências, logo, de acordo com a legislação vigente, todos os estabelecimentos privados que geram mais de 200 litros de resíduos, precisam contratar uma empresa privada para fazer a coleta, transporte, tratamento e destinação ambientalmente correta dos seus resíduos.</p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Por que devo me cadastrar no CTR-E RGG?",
            texto: () => (
                <div className='mt-2'>
                    <p> A Prefeitura de São Paulo, por meio da SP REGULA, em cumprimento as Políticas Publicas dentre elas o PGIRS – Plano de Gestão Integrada de Resíduos Sólidos da Cidade de São Paulo, almeja melhorias contínuas com o gerenciamento dos resíduos sólidos gerados na cidade.</p>

                    <p> A iniciativa pretende diminuir os impactos na coleta publica bem como melhorar as ações de zeladoria da cidade e aumentar o controle das etapas do sistema, além de minimizar a proliferação de pragas urbanas (roedores, aves e insetos) a partir da melhoria do sistema de coleta e destinação dos resíduos.
                        Portanto, o cadastramento dos estabelecimentos considerados grandes geradores é fundamental para o controle efetivo de todos os entes envolvidos.</p>
                </div>
            ),
            collapse: false
        }
    ]);

    const handleCollapse = (index) => {
        setMensagens(prevState => {
            const _mensagens = [...prevState];
            _mensagens[index] = { ..._mensagens[index], collapse: !_mensagens[index].collapse };
            return _mensagens;
        });
    }

    return <UncontrolledPopover
        className="popover"
        placement="bottom"
        target={id}
    >
        <PopoverHeader className="popover-header">
            <div
                className='d-flex justify-content-center align-items-center rounded-circle'
                style={{
                    width: "30px",
                    height: "30px",
                    border: "3px solid black",
                    background: "transparent"
                }}
            >
                <div className="text-center font-weight-bold" style={{ fontSize: "20px", color: "black" }}>
                    ?
                </div>
            </div>
            <p className='font-weight-bold mt-3' style={{ fontSize: "20px" }}>Dúvidas?</p>
        </PopoverHeader>

        <PopoverBody>
            {mensagens.map((value, index) => {
                const ContentComponent = value.title === "Manuais"
                    ? () => getManuais(setupSistema?.caminhoVirtual ?? '').map((manual, manualIndex) => (
                        <React.Fragment key={manualIndex}>
                            <div className='mt-2 mb-2 rounded p-2' style={{ border: "2px solid #b6b3b3", background: "rgb(226, 218, 218)" }}>
                                <div className='d-flex align-items-center justify-content-between w-100'
                                    type="button"
                                    onClick={() => window.open(manual.link, "_blank")}
                                >
                                    <h6 className='mb-0' style={{ fontWeight: "normal" }}>{manual.title}</h6>
                                    <i className="fas fa-file-alt"></i>
                                </div>
                            </div>
                        </React.Fragment>
                    ))
                    : value.texto;

                return <div key={index}>
                    <div className='d-flex align-items-center justify-content-between w-100'
                        type="button"
                        id={`toggler${index}`}
                        onClick={() => handleCollapse(index)}
                    >
                        <h6 className='mb-0' style={{ fontWeight: mensagens[index].collapse ? "bold" : "normal" }}>{value.title}</h6>
                        {mensagens[index].collapse ? <i className="fas fa-angle-up"></i> : <i className="fas fa-angle-down"></i>}
                    </div>
                    <UncontrolledCollapse toggler={`#toggler${index}`} className="mb-2">
                        <ContentComponent />
                    </UncontrolledCollapse>
                    <hr />
                </div>
            })}
        </PopoverBody>
        <div className='d-flex justify-content-center align-items-center mt-0'>
            <Button
                color="warning"
                onClick={() => history.push("/auth/duvidas")}
            >
                Saiba Mais
            </Button>
        </div>
    </UncontrolledPopover>;
}

export default Popover;